import { EvokeAction } from "react-evoke";
import { AppState } from "../../typings/AppState";
import { AppActions } from "../../typings/AppActions";
import { api } from "../../api";

const getCompanyDetails: EvokeAction<AppState, AppActions> = async store => {
  try {
    const details = await api.get("company/details");
    
    await store.update(state => {
      state.companyDetails = details;
    });
  } catch (error) {
    console.log("error", error);
  }
};

export const companyActions = {
    getCompanyDetails
};
